export const defaultStructureColor = 0xff0000;
export const hoveredStructureColor = 0xff9900;
export const selectedStructureColor = 0x0000ff;
export const hoveredSelectedStructureColor = 0x0099ff;
